import { createFileRoute } from "@tanstack/react-router";
import { NotificationsScreen } from "../components/settings/notifications-screen.tsx";

export const Route = createFileRoute("/installningar/aviseringar")({ component: Screen });

/**
 * No `useSettingsFranchise` guard, unlike its neighbours: these preferences belong to the
 * signed-in person and are read from `/v1/me/*`, so there is no location to resolve and
 * nothing to wait for.
 */
function Screen() {
  return <NotificationsScreen />;
}
